module.exports = __webpack_public_path__ + "img/img007.1f78604a.png";